import axios from "axios";

import store from "../redux/store"; // adjust to your actual path
import { logout } from "../redux/features/authSlice";
import { setAuthModalOpen } from "../redux/features/authModalSlice";
import { toast } from "react-toastify";
import { setExpiredModalOpen } from "../redux/features/expiredModalSlice";
import { useNavigate } from "react-router-dom";

// export const baseURL = "http://localhost:5010";
export const baseURL = "https://diamond-server-production.vercel.app";

export const publicClient = axios.create({
  // baseURL: "http://localhost:5010/api",
  baseURL: "https://diamond-server-production.vercel.app/api",
  headers: {
    "Content-Type": "application/json",
  },
});

export const privateClient = axios.create({
  // baseURL: "http://localhost:5010/api",
  baseURL: "https://diamond-server-production.vercel.app/api",
  headers: {
    "Content-Type": "application/json",
  },
});

// Add interceptor to attach token to privateClient
privateClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("actkn");
  if (token) {
    // Ensure headers exist
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

privateClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.log("🔴 AXIOS INTERCEPTOR TRIGGERED", error?.response?.status);

      store.dispatch(logout());

      store.dispatch(setExpiredModalOpen(true));
      localStorage.removeItem("actkn");
    }

    return Promise.reject(error);
  }
);
